import { magicLinkClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/solid";
import { createSignal } from "solid-js";

/**
 * ログインダイアログの開閉。
 * ヘッダーだけでなく「ログインが必要」な画面からも開けるようアプリ全体で共有する。
 */
const [loginDialogOpen, setLoginDialogOpen] = createSignal(false);

export { loginDialogOpen, setLoginDialogOpen };

/**
 * 認証クライアント。
 *
 * dev は Vite の proxy 経由 (same-origin) にして Cookie を素直に扱う。
 * 本番は Cloudflare Pages と Cloud Run が別ドメインになるため、API の origin を直接指す。
 */
const AUTH_ORIGIN = import.meta.env.DEV ? "" : (import.meta.env.VITE_API_ORIGIN ?? "");

export const authClient = createAuthClient({
  baseURL: AUTH_ORIGIN === "" ? window.location.origin : AUTH_ORIGIN,
  basePath: "/api/auth",
  fetchOptions: { credentials: "include" },
  plugins: [magicLinkClient()],
});

/** Google でログイン (config.auth.google が true のときだけ呼ぶ)。 */
export async function signInWithGoogle(callbackPath = "/"): Promise<void> {
  await authClient.signIn.social({
    provider: "google",
    callbackURL: `${window.location.origin}${callbackPath}`,
  });
}

/** メールに届くリンクでログイン。 */
export async function sendMagicLink(email: string, callbackPath = "/"): Promise<void> {
  const result = await authClient.signIn.magicLink({
    email,
    callbackURL: `${window.location.origin}${callbackPath}`,
  });
  if (result.error !== null) {
    throw new Error(result.error.message ?? "メールを送れませんでした");
  }
}

export async function signOut(): Promise<void> {
  await authClient.signOut();
}
